import React, { useContext } from "react";
import moment from "moment";
import Logo from "../image/logo.png";
import {
  Autocomplete,
  Button,
  TableRow,
  Table,
  Grid,
  TextField,
  Typography,
  Toolbar,
} from "@mui/material";

import MuiTableCell from "@material-ui/core/TableCell";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../constants/datasheetConstants.js";
import { DatasheetContext } from "./editDatasheet/datasheet.context";
import ObservedReadings from "./editDatasheet/ObservedReadings/ObservedReadings";
import DetailsOfCalStandards from "./editDatasheet/DetailsOfCalStandards";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import { datasheetsApprove, datashettAprroveWithdrawl } from "./editDatasheet/submitHandlers";
import { accuracyFormat, parseRange } from "../../utils/components/accuracyandlcandrangesshow.js";
import { generateDatasheetPDF } from "./datasheetPrint/printDatasheet.js";

const TableCell = withStyles({
  root: {
    border: "none",
    padding: "0px",
    margin: "0px",
    lineHeight: "1.32",
    fontSize: "12px",
    paddingLeft: "5px",
  },
})(MuiTableCell);

export default function ViewDatasheet(props) {
  const printComponentRef = React.useRef();
  const classes = useStyles();
  const [downloadPdfloading, setDownlaodPdfLoading] =React.useState(false);
  const [letterHead, setLetterHead] = React.useState(true);
  const [electronicSign, setElectronicSign] = React.useState(true);
  const [signImg, setSignImg] = React.useState(false);
  const datasheetContextValue = useContext(DatasheetContext);
  const {
    state: {
      srfDetails,
      datasheetDetails,
      certificateDetails,
      disciplineDetails,
      calibratedBy,
      calibratedByImgSign,
      DatasheetReadingsAdditionalInfo,
      staticTables,
      datasheetApprovedBy,
      datasheetApprovedByImgSign,
      referenceData,
      datasheetImages,
      instrumentDetails,
      settings,
      ClientSetting,
      selectedStandardMasters
    },
  } = datasheetContextValue;
  const userType = localStorage.getItem("type");

  const approvedByAuthority = (JSON.parse(localStorage.getItem("roles") || "[]").some(role => role.id == 2)) && (localStorage.getItem("disciplineID")?.includes(instrumentDetails?.disciplineId)) || "";
  let applySetting  = settings?.["Client Settings"]?.toLowerCase() === "true" ? ClientSetting : settings;

  function headerrowDetailsTable() {
    return (
      <table className="standardUnitTable " align="left">
        <tr>
          <td rowSpan="4" style={{ borderRight: "none" }}>
            <img src={Logo} height="60px" />
          </td>
          <td rowSpan="4" style={{ borderRight: "none" }}>
            <b style={{ fontSize: "14px",fontFamily: "Times New Roman, serif", }}>
            Kesar Testing Service LLP<br />
              Observation Sheet - {referenceData?.srfInstruments?.requestedDucName || datasheetDetails?.requestedname || datasheetDetails?.instrumentName}
            </b>
          </td>
        </tr>
        <tr>
          <td style={{ borderRight: "none", borderBottom: "none",fontFamily: "Times New Roman, serif", }}>
            <b>Document Number</b>
          </td>
          <td style={{ borderBottom: "none",fontFamily: "Times New Roman, serif", }}>{instrumentDetails?.datasheetFormatNumber}</td>
        </tr>
        <tr>
          <td style={{ borderRight: "none",fontFamily: "Times New Roman, serif",}}>
            <b>Issue No. / Date</b>
          </td>
          <td style={{fontFamily: "Times New Roman, serif",}}>
            {instrumentDetails?.DatasheetRevisionNumber} / {moment(instrumentDetails?.DatasheetRevisionDate).format("DD/MM/YYYY")}
          </td>
        </tr>

      </table>
    );
  }

  function customerDetailsTable() {
    return (
      <table className="standardUnitTable single-border-table" align="center">
        {datasheetDetails?.location == "Onsite" && (
        <tr>
          <td style={{ width: "16.66%" }}>
            <b>Client</b>
          </td>
          <td style={{ width: "16.66%" }} colSpan={2}>{certificateDetails?.clientName}</td>
          <td style={{ width: "16.66%" }}>
            <b>Address</b>
          </td>
          <td style={{ width: "16.66%" }} colSpan={2}>{certificateDetails?.address}</td>
        </tr>
        )}
        <tr>
          <td style={{ width: "16.66%" }}>
            <b>CRF Number</b>
          </td>
          <td style={{ width: "16.66%", fontFamily: "Times New Roman, serif", }}>{certificateDetails?.serviceReqNumber}</td>
          <td style={{ width: "16.66%", fontFamily: "Times New Roman, serif", }}>
            <b>CRF Date</b>
          </td>
          <td style={{ width: "16.66%", fontFamily: "Times New Roman, serif", }}>
            {moment(srfDetails?.entryDate).format("DD/MM/YYYY")}
          </td>
          <td style={{ width: "16.66%" }}>
            <b>Calibration Frequency</b>
          </td>
          <td style={{ width: "16.66%" }}>
          {datasheetDetails?.calibrationFrequency}
          </td>
        </tr>
      </table>
    );
  }

  function unitCalibrationDetails() {
    return (
      <Table
        className={classes.table}
        style={{ fontSize: "11px", marginBottom: "3px" }}
      >
        <TableRow className={classes.row}>
          <TableCell className={classes.infoCell} align="center">
            <TableCell
              style={{
                border: "none",
                width: "150px",
                padding: "0px",
                fontFamily: "Times New Roman, serif",
              }}
            >
              <b>Name of Instrument </b>
            </TableCell>
            <TableCell style={{ border: "none" }}>:</TableCell>
            <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
              {referenceData?.srfInstruments?.requestedDucName || datasheetDetails?.requestedname || datasheetDetails?.instrumentName}
            </TableCell>
          </TableCell>
          {datasheetDetails?.make &&
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Make</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{datasheetDetails?.make}</TableCell>
            </TableRow>
          </TableCell>
          }
        </TableRow>
        <TableRow>
          {datasheetDetails?.DUCID &&
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Identification No.</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{datasheetDetails?.DUCID}</TableCell>
            </TableRow>
          </TableCell>
          }
          {datasheetDetails?.model &&
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Model</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{datasheetDetails?.model}</TableCell>
            </TableRow>
          </TableCell>
          }
        </TableRow>
        <TableRow>
          {datasheetDetails?.serialNo &&
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Serial no. </b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{datasheetDetails?.serialNo}</TableCell>
            </TableRow>
          </TableCell>
          }          
          {datasheetDetails?.ranges &&
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Range</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {parseRange(datasheetDetails?.ranges)}
              </TableCell>
            </TableRow>
          </TableCell>
          }
        </TableRow>
        <TableRow>
          {datasheetDetails?.accuracy &&
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
                 fontFamily: "Times New Roman, serif",
               }}
             >
               <b>Accuracy</b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
              {accuracyFormat(datasheetDetails?.accuracy)}
             </TableCell>
           </TableRow>
         </TableCell>
          }
         {datasheetDetails?.lc &&
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
                 fontFamily: "Times New Roman, serif",
               }}
             >
               <b>Resolution/Least Count</b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
               {datasheetDetails?.lc
                 ?.replaceAll("||", ", ")
                 ?.replaceAll("|", " to ")
                 ?.replaceAll("#", " ")}
             </TableCell>
           </TableRow>
         </TableCell>
         }
       </TableRow>
       <TableRow>
        {datasheetDetails?.locationOfInstrument &&
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
                 fontFamily: "Times New Roman, serif",
               }}
             >
               <b>Location</b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
               {datasheetDetails?.locationOfInstrument ? datasheetDetails?.locationOfInstrument : ""}
             </TableCell>
           </TableRow>
         </TableCell>
        }
         {datasheetDetails?.location && 
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
                 fontFamily: "Times New Roman, serif",
               }}
             >
               <b>Calibration Location </b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{datasheetDetails?.location}</TableCell>
           </TableRow>
         </TableCell>
         }
       </TableRow>
       <TableRow>
        {datasheetDetails?.conOfDuc &&
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
                 fontFamily: "Times New Roman, serif",
               }}
             >
               <b>Condition of Instrument </b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{datasheetDetails?.conOfDuc}</TableCell>
           </TableRow>
         </TableCell>
        }
        {datasheetDetails?.calibrationProcedureNo &&
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
                 fontFamily: "Times New Roman, serif",
               }}
             >
               <b>Calibration Procedure</b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
               {datasheetDetails?.calibrationProcedureNo}
             </TableCell>
           </TableRow>
         </TableCell>
        }
       </TableRow>
       {(datasheetDetails?.referenceStandards || datasheetDetails?.isaStandard) &&
       <TableRow>
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
                 fontFamily: "Times New Roman, serif",
               }}
             >
               <b>Standard Reference</b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
               {datasheetDetails?.isaStandard ? datasheetDetails?.isaStandard : datasheetDetails?.referenceStandards}
             </TableCell>
           </TableRow>
         </TableCell>
       </TableRow>
       }
       <TableRow>
       {referenceData?.srfInstruments?.department &&
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
               }}
             >
               <b>Department</b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none" }}>
               {referenceData?.srfInstruments?.department}
             </TableCell>
           </TableRow>
         </TableCell>
       }
       {referenceData?.srfInstruments?.sensorType &&
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
               }}
             >
               <b>Sensor Type</b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none" }}>
               {referenceData?.srfInstruments?.sensorType}
             </TableCell>
           </TableRow>
         </TableCell>
       }
       </TableRow>
       {datasheetDetails?.operatingRange &&
       <TableRow>
         <TableCell className={classes.infoCell}>
           <TableRow style={{ border: "none", padding: "0px" }}>
             <TableCell
               style={{
                 border: "none",
                 width: "150px",
                 padding: "0px",
               }}
             >
               <b>Operating Range</b>
             </TableCell>
             <TableCell style={{ border: "none" }}>:</TableCell>
             <TableCell style={{ border: "none" }}>
               {datasheetDetails?.operatingRange
                ?.replaceAll("||", ", ")
                ?.replaceAll("|", " to ")
                ?.replaceAll("#", "")}
             </TableCell>
           </TableRow>
         </TableCell>
       </TableRow>
       }
        {datasheetDetails?.extraColumns && datasheetDetails?.extraColumns?.map((e, index) => (
            index % 2 === 0 && (
              <TableRow key={index}>
              {datasheetDetails.extraColumns[index]?.[0] && datasheetDetails.extraColumns[index]?.[1] && (
                <TableCell className={classes.infoCell}>
                  <TableRow style={{ border: "none", padding: "0px" }}>
                    <TableCell
                      style={{
                        border: "none",
                        width: "150px",
                        padding: "0px",
                        textTransform:"capitalize",
                        fontFamily: "Times New Roman, serif",
                      }}
                    >
                      <b>{datasheetDetails.extraColumns[index]?.[0] || ""}</b>
                    </TableCell>
                    <TableCell style={{ border: "none" }}>:</TableCell>
                    <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{datasheetDetails.extraColumns[index]?.[1] || ""}</TableCell>
                  </TableRow>
                </TableCell>
              )}

                {datasheetDetails.extraColumns[index + 1]?.[0] && datasheetDetails.extraColumns[index + 1]?.[1] && (
                  <TableCell className={classes.infoCell}>
                    <TableRow style={{ border: "none", padding: "0px" }}>
                      <TableCell
                        style={{
                          border: "none",
                          width: "150px",
                          padding: "0px",
                          textTransform:"capitalize",
                          fontFamily: "Times New Roman, serif",
                        }}
                      >
                        <b>{datasheetDetails.extraColumns[index + 1]?.[0] || ""}</b>
                      </TableCell>
                      <TableCell style={{ border: "none" }}>:</TableCell>
                      <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{datasheetDetails.extraColumns[index + 1]?.[1] || ""}</TableCell>
                    </TableRow>
                  </TableCell>
                )}
              </TableRow>
            )
          ))}
      </Table>
    );
  }

  let footerSignSetting = {
    calibratedBy,
    calibratedByImgSign,
    datasheetApprovedByImgSign,
    calibrationDate : datasheetDetails?.calibrationDate,
    signImg
  };

  let letterHeadAndElectronicAndDraft = {
    letterHead,
    signImg,
    electronicSign,
  };
  
  let remarksCondition = {
    settingList : settings,
    configuration : datasheetDetails?.configuration,
    complianceStatus : datasheetDetails?.complianceStatus,
    applySetting,
    // calTypeSetting,
    // calibrationReason
    datasheetImages,
  }

  let datasheetContext = {
    srfDetails,
      datasheetDetails,
      certificateDetails,
      disciplineDetails,
      calibratedBy,
      calibratedByImgSign,
      DatasheetReadingsAdditionalInfo,
      staticTables,
      datasheetApprovedBy,
      datasheetApprovedByImgSign,
      referenceData,
      instrumentDetails,
      settings,
      ClientSetting,
      selectedStandardMasters
  }

  let printProps = {
    datasheetId : props.datasheetId,
    footerSignSetting,
    letterHeadAndElectronicAndDraft,
    remarksCondition,
    setDownloadPdfloading:setDownlaodPdfLoading,
    datasheetContext
  };

  return (
    <>
    {
      datasheetApprovedBy && userType != 3 ? 
      <Toolbar style={{ padding: "0px", width: "95%", margin: "20px auto" }}>
        <Grid container spacing={2} align="left">
          <Grid item xs={6} sm={6} md={4} lg={3}>
            <Autocomplete
              size="small"
              id="combo-box-demo"
              options={[
                { id: 1, label: "With Letter Head" },
                { id: 2, label: "Without Letter Head" },
              ]}
              renderInput={(params) => (
                <TextField {...params} label="letterHead" />
              )}
              onInputChange={(event, newInputValue) => {
                if (
                  newInputValue === "With Letter Head" ||
                  newInputValue === ""
                ) {
                  setLetterHead(true);
                } else if (newInputValue === "Without Letter Head") {
                  setLetterHead(false);
                }
                // newInputValue == "Approve" ? setEnableDisable() : setEnableDisable(4+':'+result.toString());
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3}>
            <Autocomplete
              size="small"
              id="combo-box-demo"
              options={[
                { id: 1, label: "With Electronically Signed" },
                { id: 3, label: "Signature Image" },
                { id: 2, label: "Without  Electronically Signed" },
              ]}
              renderInput={(params) => (
                <TextField {...params} label="Electronically Signed" />
              )}
              onInputChange={(event, newInputValue) => {
                if (
                  newInputValue === "With Electronically Signed" ||
                  newInputValue === ""
                ) {
                  setElectronicSign(true);
                  setSignImg(false);
                } else if (newInputValue === "Without  Electronically Signed") {
                  setElectronicSign(false);
                  setSignImg(false);
              }
              else if (
                newInputValue === "Signature Image"
              ) {
                  setElectronicSign(false);
                  setSignImg(true);
                }
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={1.5}>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                generateDatasheetPDF(printProps);
              }}
            >
              Download PDF
            </Button>
          </Grid>
          {(JSON.parse(localStorage.getItem("roles") || "[]").some(role => role.id == 2)) && (
           <Grid item xs={6} sm={6} md={4} lg={2}>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                datashettAprroveWithdrawl(props.datasheetId);
              }}
            >
              Withdraw Approval
            </Button>
          </Grid>
          )}
        </Grid>
      </Toolbar>
      : 
      <Toolbar style={{ padding: "0px", width: "95%", margin: "20px auto" }}>
        <Grid container spacing={2} align="left">
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                generateDatasheetPDF(printProps);
              }}
            >
              Download Draft
            </Button>
          </Grid>
        </Grid>
      </Toolbar>
    }    
      <div id="printOnly2" ref={printComponentRef}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ border: "none" }}>
                <div
                  className="content"
                  style={{
                    fontSize: "11px",
                    margin: "20px",
                    marginTop: "0px",
                    marginBottom: "0px",
                    padding: "10px",
                    // border: "1px solid black",
                  }}
                >
                  <Table>
                    {headerrowDetailsTable()}
                    <h5 style={{ textAlign: "center", marginBottom: "5px" }}>
                      <b>
                        <u>OBSERVATION SHEET</u>
                      </b>
                    </h5>
                    {customerDetailsTable()}
                    <TableRow>
                      <TableCell colSpan={2} align="center">
                        <Typography variant="body1" component="div" className="fontTimesNewRoman">
                          Details of Unit Under Calibration(UUC)
                        </Typography>
                      </TableCell>
                    </TableRow>
                    {unitCalibrationDetails()}
                    <Table
                      className={classes.table}
                      style={{ marginBottom: "3px" }}
                    >
                      <TableRow>
                        <TableCell rowSpan={2}>
                          <b>Environmental Conditions: </b>
                        </TableCell>
                        <TableCell>
                          <span>
                            <b style={{ paddingRight: "10px" }}>
                              Start Temp :
                            </b>
                            {datasheetDetails?.startTemp?.includes('°C')
                            ? datasheetDetails?.startTemp?.replace('#', ' ')
                            : datasheetDetails?.startTemp + ' °C'}
                          </span>
                        </TableCell>
                        <TableCell>
                        <span>
                            <b style={{ paddingRight: "10px" }}>
                              End Temp :
                            </b>
                            {datasheetDetails?.endTemp?.includes('°C')
                            ? datasheetDetails?.endTemp?.replace('#', ' ')
                            : datasheetDetails?.endTemp + ' °C'}
                          </span>
                        </TableCell>
                        <TableCell>
                        <span>
                            <b style={{ paddingRight: "10px" }}>Start Humidity:</b>
                            {datasheetDetails?.startHumidity?.includes('%RH')
                            ? datasheetDetails?.startHumidity?.replace('#', ' ')
                            : datasheetDetails?.startHumidity + ' %RH'}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span>
                            <b style={{ paddingRight: "10px" }}>End Humidity:</b>
                            {datasheetDetails?.endHumidity?.includes('%RH')
                            ? datasheetDetails?.endHumidity?.replace('#', ' ')
                            : datasheetDetails?.endHumidity + ' %RH'}
                          </span>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                      <TableCell>
                          <span>
                            <b style={{ paddingRight: "10px" }}>
                              Start "p" :
                            </b>
                            {datasheetDetails?.startPressure}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span>
                            <b style={{ paddingRight: "10px" }}>End "p":</b>
                            {datasheetDetails?.endPressure}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span>
                            <b style={{ paddingRight: "10px" }}>
                              Start Liq. Temp :
                            </b>
                            {datasheetDetails?.startLiquidTemp?.includes('°C')
                            ? datasheetDetails?.startLiquidTemp?.replace('#', ' ')
                            : datasheetDetails?.startLiquidTemp + ' °C'}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span>
                            <b style={{ paddingRight: "10px" }}>End Liq. Temp :</b>
                            {datasheetDetails?.endLiquidTemp?.includes('°C')
                            ? datasheetDetails?.endLiquidTemp?.replace('#', ' ')
                            : datasheetDetails?.endLiquidTemp + ' °C'}
                          </span>
                        </TableCell>
                      </TableRow>
                    </Table>
                    <DetailsOfCalStandards isPrinting={props.isPrinting} />
                  </Table>
                  <div>
                    <div style={{ textAlign: "left" }}>
                      <div style={{ marginBottom: "5px", marginTop: "10px" }}>
                        <b>DISCIPLINE : </b>
                        {datasheetDetails?.disciplineName}
                      </div>
                      <ObservedReadings datasheetId={props.datasheetId} isPrinting={props.isPrinting} setLoader={props.setLoader} />
                    </div>
                  </div>
                  
                    {DatasheetReadingsAdditionalInfo?.length > 0 && (
                    <div style={{width:"100%", margin:"auto",pageBreakBefore:"always"}}>
                        <Grid spacing={2}>
                          {DatasheetReadingsAdditionalInfo?.sort((a, b) => a.rowIndex - b.rowIndex)?.map(
                            (item, index) => {
                              const {
                                tableId,
                                datasheetReadingId,
                                rowIndex,
                                ...rest
                              } = item;
                              const matchingTable = tableId
                                ? staticTables?.find(
                                    (table) => table?.id === parseInt(tableId)
                                  )
                                : null;

                              if (!matchingTable) return null;

                              const filteredEntries = Object?.entries(
                                rest
                              )?.filter(
                                ([key, value]) =>
                                  value !== null &&
                                  ![
                                    "rowIndex",
                                    "status",
                                    "lastModified",
                                  ]?.includes(key)
                              );

                              return (
                                // <Grid
                                //   key={index}
                                //   item
                                //   xs={12}
                                //   style={{ marginBottom: "20px" }}
                                // >
                                  <Grid key={index} container spacing={1} style={{ marginBottom: "20px" }}>
                                    {filteredEntries?.map(([key, value]) => {
                                      const imageData = value
                                        ? JSON?.parse(value)
                                        : {};

                                      return (
                                        <Grid
                                          key={key}
                                          item
                                          xs={12}
                                          md={6}
                                          lg={3}                                          
                                        >
                                          <div style={{pageBreakInside:"avoid"}}>
                                            <div style={{display:"flex",flexDirection:"column"}}>
                                            <b>{`Table Name:${matchingTable?.tableName}`}</b>
                                            <b>{`Column Name:${
                                              matchingTable[key] || key
                                            }`}</b>
                                            <b>{`Row Index:${rowIndex}`}</b>
                                            </div>
                                          <div
                                            style={{
                                              width: "100%",
                                              height: "200px"
                                            }}
                                          >
                                            <img
                                              src={imageData?.image}
                                              alt={`Image of ${key}`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                              }}
                                            />
                                          </div>
                                          </div>
                                        </Grid>
                                      );
                                    })}
                                  </Grid>
                                // </Grid>
                              );
                            }
                          )}
                        </Grid>
                        <hr
                          style={{
                            border: "1px solid black",
                            width: "100%",
                          }}
                        />
                    </div>
                    )}

                    {(applySetting?.["Compliance Status"]?.toLowerCase() === "true" || datasheetDetails?.configuration?.remark) &&  (
                    <div style={{pageBreakInside:"avoid", marginTop:"-8px"}}>
                    <div style={{border:"1px solid black", textAlign:"left", fontSize:"12px", padding:"2px"}}>
                      <b>Remarks : </b><br/>
                      <pre style={{
                                fontFamily: "Times New Roman, serif",
                                fontSize: "11px",
                                marginBottom: "0px",
                                padding: "0",
                                lineHeight: 1,
                                whiteSpace: "pre-wrap",
                                pageBreakInside: "avoid",
                              }}>
                            {/* {                      
                            applySetting?.["Compliance Status"]  && applySetting?.["Compliance Status"].toLowerCase() === "true" ? `The results ${datasheetDetails?.complianceStatus == 1 ? "" : "doesn't" } comply with acceptance criteria.\n`: ""} */}
                            {datasheetDetails?.configuration?.remark ||
                              datasheetDetails?.defaultReamrk ||
                              instrumentDetails?.instrumentRemark || ""}
                            </pre>
                          </div>
                          </div>
                    )}

                     {datasheetImages && (Array.isArray(datasheetImages)
                      ? datasheetImages[0] : datasheetImages?.split(",")?.[0]) && /\.(jpg|jpeg|png|webp)$/i.test(
                      Array.isArray(datasheetImages) ? datasheetImages[0] : datasheetImages?.split(",")?.[0]
                    ) && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "stretch",
                          padding: "0px 5px",
                          maxHeight: "115px",
                          width: "150px",
                          flexDirection: "column",
                        }}
                      >
                        <img
                          src={encodeURI(
                            Array.isArray(datasheetImages)
                              ? datasheetImages[0]
                              : datasheetImages?.split(",")?.[0] || ""
                          )}
                          alt="weighttrect"
                          style={{ height: "90%", width: "100%" }}
                        />
                          </div>
                    )}
                  <div style={{ textAlign: "center" }}>
                    --------- END OF OBSERVATION SHEET ---------
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{ width: "100%" }} id="header-section"></div>
      </div>
      {!datasheetApprovedBy && calibratedBy && userType !=3 && approvedByAuthority && (
        <div style={{ padding: "2rem 0rem", textAlign: "left" }}>
          <Button
            variant="contained"
            color="success"
            size="small"
            sx={{ ml: 3 }}
            onClick={async() => {
              await datasheetsApprove(props.datasheetId);
            }}
          >
            Approve
          </Button>
        </div>
      )}

      {downloadPdfloading && <DownloadPdfLoaderModal loading={downloadPdfloading} name={"Datasheet"} />}
    </>
  );
}
